import { BRAND_COLORS, color } from './colors';
import { spacer } from './spacings';
import { radius } from './radius';

/**
 * Styling token for the <code> element.
 */
export const code = `
  font-family: monospace;
  background-color: ${BRAND_COLORS.lilac_200};
  color: ${color.text_default};
  padding: ${spacer.x0} ${spacer.x1};
  border-radius: ${radius.m};
`;
